"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _makeStylesInternal = _interopRequireDefault(require("../makeStyles/makeStylesInternal"));
var _globalSpacing = require("./../globalSpacing");
var _tokens = require("../styles/tokens");
var _EDSContext = require("../EDSContext/EDSContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var spanAllColumns = 'span 12';
var useStyles = (0, _makeStylesInternal.default)(function (theme) {
  var _content, _contentLeft, _contentRight, _sidebar, _fixedSidebar, _fixedSidebarRight, _stickySidebar, _stickySidebarLeft, _sidebarFullWidthSm, _sidebarFullWidthMd;
  return {
    root: {
      gridTemplateColumns: 'repeat(12, minmax(0, 1fr))'
    },
    content: (_content = {
      gridColumn: spanAllColumns
    }, _content[theme.breakpoints.up('lg')] = {
      marginRight: _tokens.spacing60
    }, _content),
    contentLeft: (_contentLeft = {}, _contentLeft[theme.breakpoints.up('lg')] = {
      gridColumn: 'span 8'
    }, _contentLeft),
    contentRight: (_contentRight = {}, _contentRight[theme.breakpoints.up('lg')] = {
      gridColumn: '5 / span 8'
    }, _contentRight),
    hiddenSidebar: {
      opacity: 0,
      height: 0,
      overflow: 'hidden',
      visibility: 'hidden'
    },
    sidebar: (_sidebar = {
      gridColumn: spanAllColumns
    }, _sidebar[theme.breakpoints.up('sm')] = {
      gridColumn: 'span 6'
    }, _sidebar[theme.breakpoints.up('lg')] = {
      gridColumn: '9 / span 4'
    }, _sidebar),
    fixedSidebar: (_fixedSidebar = {}, _fixedSidebar[theme.breakpoints.up('lg')] = {
      position: 'fixed',
      width: function width(p) {
        return p.rect && p.rect.width + "px";
      },
      top: function top(p) {
        return p.sidebarTop;
      }
    }, _fixedSidebar),
    fixedSidebarRight: (_fixedSidebarRight = {}, _fixedSidebarRight[theme.breakpoints.up('lg')] = {
      left: function left(p) {
        return p.rect && p.rect.left + "px";
      }
    }, _fixedSidebarRight),
    stickySidebar: (_stickySidebar = {}, _stickySidebar[theme.breakpoints.up('lg')] = {
      position: 'sticky',
      top: function top(p) {
        return p.sidebarTop || 0;
      }
    }, _stickySidebar),
    stickySidebarLeft: (_stickySidebarLeft = {}, _stickySidebarLeft[theme.breakpoints.up('lg')] = {
      gridRow: '1',
      gridColumn: '1 / span 4'
    }, _stickySidebarLeft),
    sidebarFullWidthSm: (_sidebarFullWidthSm = {}, _sidebarFullWidthSm[theme.breakpoints.only('sm')] = {
      gridColumn: spanAllColumns
    }, _sidebarFullWidthSm),
    sidebarFullWidthMd: (_sidebarFullWidthMd = {}, _sidebarFullWidthMd[theme.breakpoints.between('sm', 'lg')] = {
      gridColumn: spanAllColumns
    }, _sidebarFullWidthMd)
  };
});

/**
 * A stationary column that remains visible at all times
 * while the rest of the page changes as a user scrolls, interacts, or progresses.
 * @done true
 * @updated v5.4.0
 * @versionAdded v4.4.0
 * @template true
 * @examples
 *  FixedSidebarLayoutExample
 *  LeftFixedSidebarLayoutExample
 *  SidebarLayoutExampleWithComponents
 *  StickySidebarLayoutExample
 */
var FixedSidebarLayout = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _cn, _cn2, _cn3, _cn4, _cn5, _cn6, _cn7, _cn8;
  var _useState = (0, _react.useState)(),
    rect = _useState[0],
    setRect = _useState[1];
  var classes = useStyles({
    rect: rect,
    sidebarTop: props.sidebarTop
  });
  var sidebarRef = (0, _react.useRef)(null);
  var hiddenSidebarRef = (0, _react.useRef)(null);
  var children = props.children,
    sidebar = props.sidebar,
    sidebarPosition = props.sidebarPosition,
    spacingOptions = props.spacingOptions,
    sidebarFullWidth = props.sidebarFullWidth,
    position = props.position;
  var _useSpacing = (0, _globalSpacing.useSpacing)((0, _extends2.default)({}, {
      outerSpacing: false
    }, spacingOptions)),
    spacingStyles = _useSpacing[0],
    setSpacingOptions = _useSpacing[2];
  var handleResize = (0, _react.useCallback)(function () {
    position === 'fixed' && setRect(hiddenSidebarRef.current.getBoundingClientRect());
  }, [position]);
  (0, _react.useEffect)(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  (0, _react.useEffect)(function () {
    setSpacingOptions(spacingOptions);
  }, [spacingOptions]); // eslint-disable-line

  (0, _react.useEffect)(function () {
    position === 'fixed' && setRect(hiddenSidebarRef.current.getBoundingClientRect());
  }, [position, props.edsContext.dir]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: (0, _classnames.default)(classes.root, props.classes && props.classes.root, spacingStyles)
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _classnames.default)(classes.content, (_cn = {}, _cn[classes.contentLeft] = sidebarPosition === 'right', _cn), (_cn2 = {}, _cn2[classes.contentRight] = sidebarPosition === 'left', _cn2), spacingStyles, props.classes && props.classes.content)
  }, children), /*#__PURE__*/_react.default.createElement("section", {
    ref: sidebarRef,
    className: (0, _classnames.default)(classes.sidebar, props.classes && props.classes.sidebar, (_cn3 = {}, _cn3[classes.fixedSidebar] = position === 'fixed', _cn3), (_cn4 = {}, _cn4[classes.fixedSidebarRight] = position === 'fixed' && sidebarPosition === 'right', _cn4), (_cn5 = {}, _cn5[classes.sidebarFullWidthSm] = sidebarFullWidth === 'sm', _cn5), (_cn6 = {}, _cn6[classes.sidebarFullWidthMd] = sidebarFullWidth === 'md', _cn6), (_cn7 = {}, _cn7[classes.stickySidebarLeft] = position === 'sticky' && sidebarPosition === 'left', _cn7))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)((_cn8 = {}, _cn8[classes.stickySidebar] = position === 'sticky', _cn8))
  }, sidebar)), position === 'fixed' && /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _classnames.default)(classes.sidebar, classes.hiddenSidebar),
    ref: hiddenSidebarRef
  }));
});
FixedSidebarLayout.muiName = 'FixedSidebarLayout';
FixedSidebarLayout.displayName = 'FixedSidebarLayout';
FixedSidebarLayout.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The content of the main section of the layout
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The contents of the sidebar
   */
  sidebar: _propTypes.default.node.isRequired,
  /**
   * Passing a string value of 'left' or 'right', the sidebar will align itself accordingly
   */
  sidebarPosition: _propTypes.default.oneOf(['left', 'right']),
  /**
   * By default `top` is automatically calculated.
   * Use this prop to override or adjust the `top` as per your need.
   * Use CSS units like `rem` or `px`.
   */
  sidebarTop: _propTypes.default.string,
  /**
   * Sets how an element is positioned in a document.
   * * `fixed`: Assumes the same position as "fixed" on initial display.
   * * `sticky`: Scroll with its contents until it reaches the absolute coordinates specified by `sidebarTop` (or the very top of the page, is `sidebarTop` is not specified)
   */
  position: _propTypes.default.oneOf(['sticky', 'fixed']),
  /**
   * Use this prop to span the sidebar to span full width (12 columns) on small (sm) or medium (md) devices or screens.
   *
   * **NOTE:** On extra small (xs) devices, sidebar will always be full width.
   */
  sidebarFullWidth: _propTypes.default.oneOf(['sm', 'md']),
  /**
   * To control `FixedSidebarLayout` spacing.
   *
   * Available options are:
   *
   * * `spacing` (string): **'standard'** | 'none' | \<object\>
   *      * Controls the padding of the `Dialog` and grid gap between child elements
   *      * `standard`: The default spacing
   *      * `none`: Removes all spacing styles, allowing for complete style customization through the `classes` prop
   *      * `object`: Allows for more fine-grained spacing customization. See [container customization documentation](#/utilities/spacing#using-customizations-for-fine-grained-container-spacing-control)
   *        for more details.
   */
  spacingOptions: _propTypes.default.shape({
    spacing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
  }),
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object
};
FixedSidebarLayout.defaultProps = {
  sidebarFullWidth: 'sm',
  position: 'fixed',
  spacingOptions: {
    outerSpacing: false
  },
  sidebarPosition: 'right'
};
var _default = exports.default = (0, _EDSContext.withEDSContext)(FixedSidebarLayout);